import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ErrorToast, SuccessToast } from '../../pure-components/CustomToast';
import API from '../../services/api';
import Validator from '../../services/validator';

import { ReactComponent as CloseModal } from "../../assets/modal-close.svg";
import { ReactComponent as Add } from '../../assets/GreenButtonRoundPlusSmall.svg';
import youtubeLogo from "../../assets/logo/youtube-icon.png";
import facebookLogo from "../../assets/logo/facebookLogo.png";
import instaLogo from "../../assets/logo/instaLogo.png";
import snapchatLogo from "../../assets/logo/snapchatLogo.png";
import xLogo from "../../assets/logo/x_logo.png";
import websiteLogo from "../../assets/logo/websiteLogo.png";
import rssLogo from "../../assets/logo/rssLogo.png";
import Constants from '../../services/constants';

export default function Channels(props) {

  const [channels, setChannels] = useState(props.channels);
  useEffect(() => {
    setChannels(props.channels)
  }, [props.channels])
  useEffect(() => {
  },[channels])

  const getChannelIcon = (type) => {
    let elem = "";
    switch(type){
      case Constants.CHANNELS.youtube : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={youtubeLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="text search"
          />
          
        </div>
        break;
      case Constants.CHANNELS.facebook : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={facebookLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="youtube link search"
          />
        </div>
        break;
      case Constants.CHANNELS.instagram : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={instaLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="spotify link search"
          />
        </div>
        break;
      case Constants.CHANNELS.snapchat : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={snapchatLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="spotify link search"
          />
        </div>
        break;
      case Constants.CHANNELS.x : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={xLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="spotify link search"
          />
        </div>
        break;
      case Constants.CHANNELS.website : 
        elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
          <img
            src={websiteLogo}
            alt="logo"
            className="h-6 mt-1 mr-1"
            title="spotify link search"
          />
        </div>
        break;
    case Constants.CHANNELS.rss : 
      elem = <div class="rounded-full filter-tile-pink text-title px-2 mt-2 pb-1 row-line">
        <img
          src={rssLogo}
          alt="logo"
          className="h-6 mt-1 mr-1"
          title="spotify link search"
        />
      </div>
      break;
    }

    return (elem)
  }

  const handleInputChange = (e, channel) => {
    let {value} = e.target;
    if(value?.length === 0)
      return;
    let tempData = {...channels};
    let idx = tempData[channel]?.length > 0 ? tempData[channel]?.length : 0; 
    //for SOLO, qadding only one channel
    if(props.userType === Constants.USER_TYPE.SOLO)
      idx =0;
    //if there is already 4 channels added for the PRO user
    if(props.userType === Constants.USER_TYPE.SOLO_PRO && idx > 3)
      return;

    tempData[channel][idx] = value;
    setChannels(tempData);
  }

  const addChannel = (channel) =>{
    if(channels[channel][channels[channel].length]?.length === 0)
      return;
    let tempData = {...channels};
    tempData[channel] = [...tempData[channel]];
    setChannels(tempData);
    props.setChannels(tempData);
    // props.setUser({...props.userData, channels : tempData});
  }

  const removeChannel = (channel, idx) => {
    console.log("channel data :", channel, idx)
    if(idx > -1){
        let tempChannels = {...channels};
        console.log("channel : ", tempChannels)
        let removedValue = tempChannels[channel]?.splice(idx, 1);
        if(idx === 0 && tempChannels[channel]?.length === 0)
            tempChannels[channel] = [""];

        console.log("channel2 : ", tempChannels, removedValue)
        setChannels(tempChannels);
        props.setChannels(tempChannels);
        // props.setUser({...props.userData, channels : tempChannels});
    }
  }
  return (
    <div className='w-full flex flex-wrap border rounded bg-gray-300 p-1'>
    {
    Object.keys(channels)?.map(channel => 
    <div className='w-full sm:w-1/2'>
      <div className='w-full flex self-center'>
        <div >{getChannelIcon(channel)}</div>
        <div className='w-full p-1 flex-wrap'>
            {/* <div className='text-sm'>{channel}</div> */}
          <TextField
            type='text'
            size='small'
            className='w-full'
            label={channel}
            variant="outlined"
            value={channels[channel][channels[channel].length]}
            // onChange={(e) => handleInputChange(e, channel, channels[channel]?.length > 0 ? channels[channel]?.length : 0)}
            onBlur={(e) => handleInputChange(e, channel)}
            disabled={(props.userType === Constants.USER_TYPE.SOLO && channels[channel]?.length >= 1) 
              || (props.userType === Constants.USER_TYPE.SOLO_PRO && channels[channel]?.length >= 4)}
          />
        </div>
        {((props.userType === Constants.USER_TYPE.SOLO_PRO && channels[channel]?.length < 4) || 
      (props.userType === Constants.USER_TYPE.SOLO && (channels[channel]?.length === 0  || channels[channel][0]?.length === 0))) && <Add className="addbutton mt-1.5 mr-2 cursor-pointer text-gray-800" onClick={() => addChannel(channel)} />}
        </div>
        {channels[channel]?.map((elem, index) => 
        elem?.length > 0 &&
        <div className='w-full p-1 flex'>
            <div className='text-sm pl-12'>{elem}</div>
            {props.editChannel && <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer text-gray-800" onClick={() => removeChannel(channel, index)} />}
        </div>)}
      </div>
    )}
    </div>
  )}